module.exports = __webpack_public_path__ + "static/media/ourDirection2.d551313c.jpg";